import React, { useState } from "react";
import EmailBlacklistDetails from "../components/email-blacklist/EmailBlacklistDetails";

function EmailBlacklist() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  return (
    <>
      <div>
        <div className="page-title">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6 d-flex align-items-center justify-content-between justify-content-md-start mb-3 mb-md-0">
              <div className="d-inline-block">
                <h5 className="h4 d-inline-block font-weight-400 mb-0 text-white">
                  Email Blacklist
                </h5>
              </div>
            </div>

            <div className="col-md-6 d-flex align-items-center justify-content-between justify-content-md-end">
              <button
                onClick={() => {
                  setShowCreateModal(true);
                }}
                className="btn btn-sm btn-white btn-icon-only rounded-circle ml-4"
              >
                <span className="btn-inner--icon">
                  <i className="fas fa-plus"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        <EmailBlacklistDetails
          showCreateModal={showCreateModal}
          setShowCreateModal={setShowCreateModal}
        />
      </div>
    </>
  );
}
export default EmailBlacklist;
